package gr.tech.meetinggenie.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.meetinggenie.styles.ButtonStyle
import gr.tech.meetinggenie.styles.CloseIconStyle
import gr.tech.meetinggenie.styles.ErrorTextStyle
import gr.tech.meetinggenie.styles.ModalCardStyle
import gr.tech.meetinggenie.styles.ModalTitleStyle
import gr.tech.meetinggenie.styles.TextInputStyle
import gr.tech.meetinggenie.styles.WhiteButtonStyle
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.onSubmit
import org.jetbrains.compose.web.attributes.type
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun CreateMeetingModal(
    isOpen: Boolean,
    isLoading: Boolean,
    error: String,
    onDismiss: () -> Unit,
    onCreate: (String) -> Unit,
) {
    var title     by remember { mutableStateOf("") }
    var errorText by remember { mutableStateOf(error) }

    fun handleCreate() {
        if (title.isBlank()) { errorText = "Please enter a title."; return }
        onCreate(title)
    }

    ModalOverlay(isOpen = isOpen, onClose = onDismiss) {
        Column(
            modifier = ModalCardStyle.toModifier()
                .padding(1.5.cssRem)
                .width(min(480.px, 100.percent - 2.cssRem)),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                H2(attrs = ModalTitleStyle.toModifier().toAttrs()) { Text("New Meeting") }

                FaX(modifier = CloseIconStyle.toModifier().onClick { onDismiss() })
            }

            Form(
                attrs = Modifier.fillMaxWidth().toAttrs {
                    onSubmit { it.preventDefault(); handleCreate() }
                }
            ) {

                Input(
                    type = InputType.Text,
                    attrs = TextInputStyle.toModifier()
                        .margin(bottom = 8.px)
                        .toAttrs {
                            attr("placeholder", "Meeting Title")
                            onInput { title = it.value }
                        }
                )

            }

            if (errorText.isNotEmpty()) {
                SpanText(errorText, modifier = ErrorTextStyle.toModifier())
            }

            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Button(
                    attrs = WhiteButtonStyle.toModifier()
                        .onClick { onDismiss() }
                        .toAttrs()
                ) { Text("Cancel") }

                Button(
                    attrs = ButtonStyle.toModifier()
                        .toAttrs {
                            type(ButtonType.Submit)
                            onClick { handleCreate() }
                        }
                ) { Text(if (isLoading) "Creating..." else "Create") }
            }
        }
    }
}
